import { ControllerFactory } from '@main/factories/controller.factory';
import { SCV_MSG_CHANNEL_NAME } from '@main/config/scv.config';

export type NumberSelectedDto = {
  number: string;
  lineId: number;
};
export type NumberSelectedMessageType = 'SCV.NUMBER_SELECTED';

export type ScvMessageTypes = NumberSelectedMessageType;
export type ScvMessage = {
  type: ScvMessageTypes;
  data: never;
};

export type ScvMessageHandlerMap = {
  [K in ScvMessageTypes]: K extends NumberSelectedMessageType
    ? (data: NumberSelectedDto) => Promise<void>
    : never;
};

export class ScvMessageHandler {
  private static channel = new BroadcastChannel(SCV_MSG_CHANNEL_NAME);

  private static messageHandlerMap: ScvMessageHandlerMap = {
    'SCV.NUMBER_SELECTED': this.numberSelectedHandler,
  };

  private static async numberSelectedHandler(data: NumberSelectedDto) {
    const controller = ControllerFactory.buildSetOutboundNumberController();
    controller.handle(data);
  }

  private static forwardMsgToBroadcastChannel(message: ScvMessage) {
    this.channel.postMessage(message);
  }

  static async sendMessage(message: ScvMessage): Promise<void> {
    const { type, data } = message;
    const handler = this.messageHandlerMap[type];
    if (handler) {
      handler(data);
    } else {
      this.forwardMsgToBroadcastChannel(message);
    }
  }
}
